const appConfig = {
  PRODUCT_FALCON_URL: process.env.REACT_APP_FALCON_APP_URL,
  PRODUCT_CC_URL: process.env.REACT_APP_CC_URL,
};
export default appConfig;
